import angular from "angular";
angular.module("cardspotWeb.services", []);